import { CouponType } from "@reef-os/utils/enums/couponType"
import { MenuType } from "@reef-os/utils/enums/menuType"
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"
import { BusinessType } from "@reef-os/utils/enums/businessType"
import { BusinessEventType } from "@reef-os/utils/enums/businessEventType"
import { EventStatus } from "@reef-os/utils/enums/eventStatus"
import { PaymentType } from "@reef-os/utils/enums/paymentType"
import moment from "moment"
import "moment-timezone"
import momentUtils from "@/moment-utils"
import router from "@/router"

export default {
	table: state => {
		if (!state.business || !state.user) {
			return state.table
		}
		return state.business.type == BusinessType.RESIDENTIAL
			? state.user.apartmentNumber
			: state.table
	},
	currentItemPrice: state =>
		(state.currentItem.calcedPrice || state.currentItem.price) *
			state.currentItem.quantity +
		(state.suggestedItemSelected.price
			? state.suggestedItemSelected.price
			: 0),
	inStockMenus: (state, getters) => {
		const isEventRoute =
			router.app.$route.meta.isEvent === true &&
			router.app.$route.params.eventId != undefined
		if (isEventRoute) {
			const menu = state.business.menus.find(
				menu => menu.event_id == router.app.$route.params.eventId
			)
			return menu ? [menu] : []
		} else if (state.deliveryDate != null) {
			const today = moment()
			const todayTime = moment(momentUtils.todaysTime(), "HH:mm")
			let preorderDate = moment(state.deliveryDate.date, "YYYY-MM-DD")
			let preorderDow = momentUtils.normalizeDayOfWeek(preorderDate)
			let preorderTime = state.deliveryDate.time
				? moment.utc(state.deliveryDate.time, "HH:mm")
				: null
			let menus = state.business.menus.filter(menu => {
				if (!state.menuSchedules[menu.id]) {
					window.bugsnagClient.notify(
						`Menu schedule not found for menuId: ${menu.id}`
					)
				}

				//Special Out of Stock Clauses
				if (
					menu.type == MenuType.POPUP ||
					menu.type == MenuType.PRE_PACKAGED ||
					menu.type == MenuType.ECOMMERCE ||
					menu.type == MenuType.DONATION
				) {
					return false
				} else if (menu.is_backup) {
					return false
				}

				let schedule =
					state.menuSchedules[menu.id] &&
					state.menuSchedules[menu.id][preorderDow]
						? state.menuSchedules[menu.id][preorderDow]
						: []
				let availableMenu = schedule.find(day => {
					if (preorderTime) {
						let todaysDow = momentUtils.todaysDow({
							utc: true
						})
						if (todaysDow == day.rangesFrom) {
							const todaysTime = moment
								.utc()
								.add(
									state.business.timezone_offset_adjusted,
									"m"
								)
							const shouldBeInStock = momentUtils.isBetweenTimes(
								todaysTime,
								day.openTime,
								day.closeTime
							)
							if (shouldBeInStock && !menu.stock_status) {
								return false
							}
						}
						return momentUtils.isBetweenTimes(
							preorderTime,
							day.openTime,
							day.closeTime
						)
					} else if (preorderDate.isSame(today, "day")) {
						return (
							day.dow == preorderDow &&
							momentUtils.isBeforeTime(todayTime, day.closeTime)
						)
					} else {
						return day.dow == preorderDow
					}
				})
				return availableMenu != undefined
			})

			if (menus.length == 0) {
				const backupMenu = state.business.menus
					.filter(menu => menu.is_backup)
					.find(menu => {
						if (
							menu.type == MenuType.POPUP ||
							menu.type == MenuType.PRE_PACKAGED ||
							menu.type == MenuType.ECOMMERCE ||
							menu.type == MenuType.DONATION
						) {
							return false
						} else if (!menu.is_backup) {
							return false
						}

						let schedule =
							state.menuSchedules[menu.id] &&
							state.menuSchedules[menu.id][preorderDow]
								? state.menuSchedules[menu.id][preorderDow]
								: []
						let availableMenu = schedule.find(day => {
							const openTime = moment.utc(day.openTime, "HH:mm")
							const closeTime = moment
								.utc(day.closeTime, "HH:mm")
								.subtract(1, "m")
							if (preorderTime) {
								return (
									preorderTime.isSameOrAfter(openTime) &&
									preorderTime.isSameOrBefore(closeTime)
								)
							} else {
								return day.dow == preorderDow
							}
						})
						return menu.is_backup && availableMenu
					})
				if (backupMenu) {
					menus.push(backupMenu)
				}
			}
			return menus
		} else if (
			state.business &&
			state.business.menus &&
			!getters.preorderOnly
		) {
			return state.business.menus.filter(menu => {
				const isNot2GoMenu =
					menu.type != MenuType.ECOMMERCE &&
					menu.type != MenuType.DONATION
				const isNotPrepackagedMenu = menu.type != MenuType.PRE_PACKAGED
				return (
					isNot2GoMenu &&
					isNotPrepackagedMenu &&
					menu.stock_status == 1
				)
			})
		} else {
			return []
		}
	},
	menuBrandsMap: (state, getters) => {
        return getters.inStockMenus.reduce((map, menu) => {
        if (menu.brand_id != null && menu.brand_id != undefined) {
            map[menu.id] = menu.brand_id
        }
        return map
        }, {})
    },
	asapAvailable: (state, getters) => {
		if (state.business && state.business.menus) {
			if (getters.preorderOnly) {
				return false
			}

			const inStockMenus = state.business.menus.filter(menu => {
				return (
					menu.stock_status == 1 &&
					menu.type != MenuType.DONATION &&
					menu.type != MenuType.ECOMMERCE &&
					menu.type != MenuType.PRE_PACKAGED
				)
			})
			return inStockMenus.length > 0
		} else {
			return false
		}
	},
	price: state =>
		state.cart.reduce(
			(total, { quantity, calcedPrice }) =>
				total + quantity * calcedPrice,
			0
		),
	totalTip: state =>
		state.tipCustom > 0
			? state.tipCustom
			: (state.tipPer *
					state.cart.reduce(
						(total, { quantity, calcedPrice }) =>
							total + quantity * calcedPrice,
						0
					)) /
			  100,
	totalPrice: state =>
		parseFloat(
			state.cart.reduce((total, { quantity, calcedPrice }) => {
				return total + quantity * calcedPrice
			}, 0)
		) +
		parseFloat(
			state.tipCustom > 0
				? state.tipCustom
				: (state.tipPer *
						state.cart.reduce(
							(total, { quantity, calcedPrice }) =>
								total + quantity * calcedPrice,
							0
						)) /
				  100
		),
	deliveryFee: (state, getters) => {
		let fee = 0
		const menus = {}
		getters.inStockMenus.forEach(menu => (menus[menu.id] = menu))

		for (var i = 0; i < state.cart.length; i++) {
			const product = state.cart[i]
			let menu = menus[product.menu_id]
			const deliveryFeeEnabled =
				getters.isAirport &&
				menu.delivery_mode == DeliveryMode.DIRECT_TO_LOCATION
			if (menu && menu.delivery_fee > fee && deliveryFeeEnabled) {
				fee = menu.delivery_fee
			}
		}

		return fee
	},
	totalTaxFees: state => {
		return (
			(state.cart.reduce((total, { quantity, calcedPrice }) => {
				return total + quantity * calcedPrice
			}, 0) *
				(state.business.tax + state.business.service_fee)) /
			100
		)
	},
	totalCheckoutPrice: (state, getters) => {
		let totalPrice = 0
		if (state.coupon.couponType == CouponType.VOUCHER) {
			totalPrice =
				getters.totalPrice +
				getters.totalTaxFees +
				getters.deliveryFee -
				state.discount
			totalPrice = totalPrice <= 1 ? 0 : totalPrice
		} else {
			totalPrice =
				getters.totalPrice +
				getters.totalTaxFees +
				getters.deliveryFee -
				Math.min(state.discount, getters.totalPrice)
			if (
				getters.totalPrice -
					Math.min(state.discount, getters.totalPrice) ==
				0
			) {
				totalPrice = totalPrice + getters.totalTip
			}
		}
		return parseFloat(totalPrice).toFixed(2)
	},
	itemsInCartCount: state =>
		state.cart.reduce((total = 0, { quantity }) => total + quantity, 0),
	minimumOrderAmount: (state, getters) => {
		let amount = 0
		if (
			state.business &&
			state.business.menus &&
			state.business.menus.length > 0
		) {
			getters.inStockMenus.forEach(menu => {
				if (
					menu.min_order_amount > amount &&
					menu.min_order_amount !== 0
				) {
					amount = menu.min_order_amount
				}
			})
		}
		if (
			state.business &&
			state.business.min_order_amount &&
			amount === 0 &&
			!getters.isPopup
		) {
			amount = state.business.min_order_amount
		}
		return amount
	},
	isPopup: (state, getters) => {
		const menus = Object.values(getters.inStockMenus)
		return menus.some(menu => menu.type == MenuType.POPUP)
	},
	cartHasOnlyAlcohol: state =>
		state.cart.every(product => product.contains_alcohol == 1),
	menuType: (state, getters) => {
		if (!state.business || !state.business.menus) {
			return MenuType.DEFAULT
		}
		const menuTypes = getters.inStockMenus.reduce((menuTypes, menu) => {
			if (!menuTypes.includes(menu.type)) {
				menuTypes.push(menu.type)
			}
			return menuTypes
		}, [])
		if (menuTypes.length > 1 && menuTypes.includes(MenuType.ESSENTIALS)) {
			return menuTypes.find(menuType => menuType != MenuType.ESSENTIALS)
		} else {
			return menuTypes.length > 0 ? menuTypes[0] : MenuType.DEFAULT
		}
	},
	cartMenuType: state => {
		if (!state.cart || state.cart.length <= 0) {
			return MenuType.DEFAULT
		}
		const menuTypesInCart = state.cart.reduce((menuTypes, product) => {
			if (!menuTypes.includes(product.menu_type)) {
				menuTypes.push(product.menu_type)
			}
			return menuTypes
		}, [])
		if (menuTypesInCart.includes(MenuType.POPUP)) {
			return MenuType.POPUP
		} else if (
			menuTypesInCart.length > 1 &&
			menuTypesInCart.includes(MenuType.ESSENTIALS)
		) {
			return menuTypesInCart.find(
				menuType => menuType != MenuType.ESSENTIALS
			)
		} else {
			return menuTypesInCart[0]
		}
	},
	cartDeliveryModes: (state, getters) => {
		if (!state.cart || state.cart.length <= 0 || !state.business) {
			return null
		}

		const menuIds = state.cart.reduce((menuIds, product) => {
			if (!menuIds.includes(product.menu_id)) {
				menuIds.push(product.menu_id)
			}
			return menuIds
		}, [])

		const menusHash = getters.menusHash
		let deliveryModes = null
		let defaultDeliveryModes = []

		menuIds.forEach(menuId => {
			let menu = menusHash[menuId] ? menusHash[menuId].menu : null
			let menuDeliveryModes =
				menu && menu.delivery_modes
					? menu.delivery_modes
					: state.business.delivery_modes

			if (menuDeliveryModes && menuDeliveryModes.length > 0) {
				let menuDefaultDeliveryMode = null
				menuDeliveryModes = menuDeliveryModes.map(deliveryMode => {
					if (deliveryMode.is_default) {
						menuDefaultDeliveryMode = deliveryMode.delivery_mode
					}
					return deliveryMode.delivery_mode
				})
				if (!deliveryModes) {
					deliveryModes = menuDeliveryModes
					defaultDeliveryModes.push(menuDefaultDeliveryMode)
				} else {
					deliveryModes = deliveryModes.filter(deliveryMode =>
						menuDeliveryModes.includes(deliveryMode)
					)
					defaultDeliveryModes = defaultDeliveryModes.filter(
						deliveryMode => menuDeliveryModes.includes(deliveryMode)
					)
				}
			} else {
				deliveryModes = []
			}
		})

		if (!deliveryModes || deliveryModes.length == 0) {
			return state.business.delivery_modes.map(deliveryMode => {
				return {
					deliveryMode: deliveryMode.delivery_mode,
					isDefault: deliveryMode.is_default
				}
			})
		} else {
			let defaultDeliveryMode =
				defaultDeliveryModes && defaultDeliveryModes.length > 0
					? defaultDeliveryModes[0]
					: deliveryModes[0]
			return deliveryModes.map(deliveryMode => {
				return {
					deliveryMode: deliveryMode,
					isDefault: defaultDeliveryMode == deliveryMode
				}
			})
		}
	},
	showCartDeliveryFee: (state, getters) => {
		if (getters.cartMenuType == MenuType.POPUP) {
			const popupMenuId = state.cart.find(
				product => product.menu_type == MenuType.POPUP
			)
			const menu = getters.menusHash[popupMenuId]
			const event =
				menu &&
				menu.event_id &&
				state.businessEvents.find(event => event.id == menu.event_id)
			if (event) {
				return event.type != BusinessEventType.POPUP
			}
		}
		if (getters.isAirport) {
			return (
				state.deliveryMode == DeliveryMode.DIRECT_TO_LOCATION &&
				getters.deliveryFee > 0
			)
		}
		return true
	},
	deliveryMode: (state, getters) => {
		if (state.deliveryMode != null) {
			return state.deliveryMode
		} else if (getters.cartDeliveryModes) {
			const deliveryMode = getters.cartDeliveryModes.find(
				deliveryMode => deliveryMode.isDefault
			)
			if (deliveryMode) {
				return deliveryMode.deliveryMode
			}
		} else if (state.business) {
			const deliveryMode = state.business.delivery_modes.find(
				deliveryMode => deliveryMode.is_default
			)
			if (deliveryMode) {
				return deliveryMode.delivery_mode
			}
		}

		return DeliveryMode.DIRECT_TO_LOCATION
	},
	allowedPaymentMethods: (state, getters) => {
		let paymentMethods = [
			PaymentType.CREDIT_CARD,
			PaymentType.APPLE_PAY,
			PaymentType.GOOGLE_PAY
		]

		if (
			!state.business ||
			!state.business.menu_payment_methods ||
			getters.itemsInCartCount == 0
		) {
			return paymentMethods
		}

		if (state.business.type == BusinessType.HOTEL) {
			paymentMethods.push(PaymentType.IN_ROOM_BILLING)
		}

		const menuIdsInCart = state.cart.reduce((menuIds, product) => {
			if (!menuIds.includes(product.menu_id)) {
				menuIds.push(product.menu_id)
			}
			return menuIds
		}, [])
		const menusPaymentMethods = state.business.menu_payment_methods.reduce(
			(menus, paymentMethod) => {
				if (!menus[paymentMethod.menu_id]) {
					menus[paymentMethod.menu_id] = []
				}
				menus[paymentMethod.menu_id].push(paymentMethod.type)
				return menus
			},
			{}
		)
		menuIdsInCart.forEach(menuId => {
			const allowedPaymentMethods = menusPaymentMethods[menuId]
			if (allowedPaymentMethods) {
				paymentMethods = paymentMethods.filter(method =>
					allowedPaymentMethods.includes(method)
				)
			} else {
				paymentMethods = [
					PaymentType.CREDIT_CARD,
					PaymentType.APPLE_PAY,
					PaymentType.GOOGLE_PAY
				]
			}
		})
		return paymentMethods
	},
	fullPreorderDate: state => {
		if (
			state.deliveryDate &&
			state.deliveryDate.date &&
			state.deliveryDate.time
		) {
			const timezone =
				state.business && state.business.timezone
					? state.business.timezone
					: ""
			let preorderDate = `${state.deliveryDate.date} ${
				state.deliveryDate.time
			}`
			return moment
				.tz(preorderDate, "YYYY-MM-DD HH:mm:ss", timezone)
				.utc()
		}
		return null
	},
	businessSchedule: state => {
		if (!state.business || !state.business.opening_hours) {
			return []
		}
		let hours = state.business.opening_hours.slice()
		if (hours) {
			let schedule = {}
			let scheduleSummary = []
			hours
				.sort((a, b) => a.day_of_week - b.day_of_week)
				.forEach(hour => {
					if (
						schedule[`${hour.open_time}-${hour.close_time}`] ==
						undefined
					) {
						schedule[`${hour.open_time}-${hour.close_time}`] = [
							hour.day_of_week
						]
					} else {
						schedule[`${hour.open_time}-${hour.close_time}`].push(
							hour.day_of_week
						)
					}
				})
			const daily = {
				0: "Mon.",
				1: "Tue.",
				2: "Wed.",
				3: "Thu.",
				4: "Fri.",
				5: "Sat.",
				6: "Sun."
			}
			for (let hours in schedule) {
				let days = schedule[hours].sort()
				let isRange = days.length > 2

				for (var i = 1; i < days.length; i++) {
					let day = days[i]
					let prevDay = days[i - 1]
					if (day != prevDay + 1) {
						isRange = false
						break
					}
				}

				if (isRange) {
					days.splice(1, days.length - 2)
					days = days.map(day => daily[day])
				} else {
					days = days.map(day => daily[day])
				}
				const time = hours.split("-").map(time =>
					moment(time, "hh:mm")
						.add(state.business.timezone_offset, "m")
						.format("h:mm A")
				)
				scheduleSummary.push({
					days: days,
					times: time,
					isRange: isRange
				})
			}

			return scheduleSummary
		}
		return []
	},
	residentialMenuStartDate: (state, getters) => {
		let dow = momentUtils.todaysDow()
		const todaysDow = momentUtils.todaysDow()
		const todaysTime = moment
			.utc()
			.add(state.business.timezone_offset_adjusted, "m")
		const todaysDate = todaysTime.format("YYYY-MM-DD")

		const schedules = {}
		Object.keys(state.menuSchedules).forEach(menuId => {
			Object.values(state.menuSchedules[menuId]).map(schedule => {
				if (schedule.length > 0) {
					schedule.forEach(day => {
						if (schedules[day.dow] == undefined) {
							schedules[day.dow] = []
						}
						schedules[day.dow].push({
							openTime: day.openTime,
							closeTime: day.closeTime,
							menuInStock:
								getters.menusHash[menuId].menu.stock_status
						})
					})
				}
			})
		})

		for (var i = 0; i < 7; i++) {
			const schedule = schedules[dow]
			if (schedule) {
				const isToday = todaysDow == dow
				const openSchedule = schedule.find(day => {
					if (isToday) {
						const shouldBeInStock = momentUtils.isBetweenTimes(
							todaysTime,
							day.openTime,
							day.closeTime
						)
						if (shouldBeInStock && !day.menuInStock) {
							return false
						} else {
							return todaysTime.isSameOrBefore(
								moment.utc(
									`${todaysDate} ${day.closeTime}`,
									"YYYY-MM-DD HH:mm"
								)
							)
						}
					}
					return true
				})
				if (openSchedule) {
					return momentUtils
						.findDowFromToday(dow)
						.format("YYYY-MM-DD")
				}
			}
			if (dow >= 6) {
				dow = 0
			} else {
				dow += 1
			}
		}
		return null
	},
	preorderOnly: state => {
		if (state.business) {
			if (
				state.business.is_active == 0 &&
				router.app.$route.meta.preview != true
			) {
				return false
			}
			if (state.business.type == BusinessType.RESIDENTIAL) {
				return false
			}
			if (state.business.allow_asap != undefined) {
				return !state.business.allow_asap
			}
		}
		return false
	},
	preorderOnlySlots: (state, getters) => {
		if (!state.business || !state.business.menus || !getters.preorderOnly) {
			return null
		}
		const timezone = state.business.timezone ? state.business.timezone : ""
		const availableDays = {}
		let workingMoment = moment.tz(timezone).startOf("d")
		for (let i = 0; i < 5; i++) {
			availableDays[workingMoment.format("YYYY-MM-DD")] = {
				slots: [],
				dow: momentUtils.normalizeDayOfWeek(workingMoment)
			}
			workingMoment.add(1, "d")
		}

		const availableMenus = state.business.menus.filter(menu => {
			const isDefaultMenu = menu.type == MenuType.DEFAULT
			const isEssentialsMenu = menu.type == MenuType.ESSENTIALS
			const hasMenuSchedule =
				menu.opening_hours && menu.opening_hours.length > 0
			return (isDefaultMenu || isEssentialsMenu) && hasMenuSchedule
		})

		if (availableMenus.length > 0) {
			availableMenus.forEach(menu => {
				const schedules = state.menuSchedules[menu.id]
				const todaysDate = momentUtils.todaysDate()
				if (menu.delivery_slots && menu.delivery_slots.length > 0) {
					const deliverySlots = menu.delivery_slots
						.map((slotTime, index) => {
							return {
								time: slotTime.time,
								localTime: menu.slots[index],
								cutoff_delta: slotTime.cutoff_delta
							}
						})
						.sort(
							(a, b) =>
								momentUtils.numericalTime(a.localTime) -
								momentUtils.numericalTime(b.localTime)
						)

					for (let availableDay in availableDays) {
						const dow = availableDays[availableDay].dow
						const dailySchedules = schedules[dow]
						const availableDayMoment = moment(
							availableDay,
							"YYYY-MM-DD"
						)
						const isToday = momentUtils.isSameDay(
							availableDayMoment,
							todaysDate
						)
						availableDays[availableDay].isToday = isToday

						if (isToday) {
							const now = moment.tz(timezone)
							let todaysSchedule = Object.values(schedules)
								.flat()
								.filter(schedule => schedule.rangesFrom == dow)
							let shouldBeInStock = todaysSchedule.some(
								todaySchedule => {
									return momentUtils.isBetweenTimes(
										now,
										todaySchedule.openTime,
										todaySchedule.closeTime
									)
								}
							)
							if (shouldBeInStock && menu.stock_status == 0) {
								continue
							}
						}

						deliverySlots.forEach(slot => {
							if (slot.time) {
								//Is it past the cutoff?
								if (slot.cutoff_delta) {
									const cutoffOffset = slot.cutoff_delta
									const cutoffDate = moment(
										`${availableDay} ${slot.localTime}`,
										"YYYY-MM-DD HH:mm:ss",
										timezone
									)
										.add(cutoffOffset, "m")
										.utc()

									const now = moment.utc()
									if (cutoffDate.isSameOrBefore(now)) {
										return false
									}
								}

								const slotMoment = moment(
									`${availableDay} ${slot.localTime}`,
									"YYYY-MM-DD HH:mm:ss"
								)

								//In the past?
								if (isToday) {
									const dailyCutoff = moment
										.utc()
										.add(60, "m")
									if (
										slotMoment
											.clone()
											.utc()
											.isSameOrBefore(dailyCutoff)
									) {
										return false
									}
								}

								const slotMomentLocal = moment.utc(
									`${slotMoment.format(
										"YYYY-MM-DD"
									)} ${slotMoment.format("HH:mm:ss")}`,
									"YYYY-MM-DD HH:mm:ss"
								)

								//Does it fit within the menu schedule?
								const fitsWithinSchedule = dailySchedules.some(
									dailySchedule => {
										const openMoment = moment.utc(
											`${availableDay} ${
												dailySchedule.openTime
											}`,
											"YYYY-MM-DD HH:mm:ss"
										)
										const closeMoment = moment.utc(
											`${availableDay} ${
												dailySchedule.closeTime
											}`,
											"YYYY-MM-DD HH:mm:ss"
										)
										return slotMomentLocal.isBetween(
											openMoment,
											closeMoment,
											"m",
											"[]"
										)
									}
								)
								if (!fitsWithinSchedule) {
									return
								}

								if (
									!availableDays[availableDay].slots.includes(
										slot.localTime
									)
								) {
									availableDays[availableDay].slots.push(
										slot.localTime
									)
								}
							} else if (slot.cutoff_delta) {
								momentUtils
									.generateTimeSlots(
										dailySchedules,
										false,
										isToday,
										15,
										slot.cutoff_delta
									)
									.forEach(generatedSlot => {
										if (
											!availableDays[
												availableDay
											].slots.includes(generatedSlot.time)
										) {
											availableDays[
												availableDay
											].slots.push(generatedSlot.time)
										}
									})
							}
						})
					}
				} else {
					for (let availableDay in availableDays) {
						const dow = availableDays[availableDay].dow
						const dailySchedules = schedules[dow]
						const availableDayMoment = moment(
							availableDay,
							"YYYY-MM-DD"
						)
						const isToday = momentUtils.isSameDay(
							availableDayMoment,
							todaysDate
						)
						if (isToday) {
							const now = moment.tz(timezone)
							let todaysSchedule = Object.values(schedules)
								.flat()
								.filter(schedule => schedule.rangesFrom == dow)
							let shouldBeInStock = todaysSchedule.some(
								todaySchedule => {
									return momentUtils.isBetweenTimes(
										now,
										todaySchedule.openTime,
										todaySchedule.closeTime
									)
								}
							)
							if (shouldBeInStock && menu.stock_status == 0) {
								continue
							}
						}
						momentUtils
							.generateTimeSlots(
								dailySchedules,
								false,
								isToday,
								15
							)
							.forEach(generatedSlot => {
								if (
									!availableDays[availableDay].slots.includes(
										generatedSlot.time
									)
								) {
									availableDays[availableDay].slots.push(
										generatedSlot.time
									)
								}
							})
					}
				}
			})
		}
		for (let availableDay in availableDays) {
			availableDays[availableDay].slots = availableDays[
				availableDay
			].slots.sort(
				(a, b) =>
					momentUtils.numericalTime(a) - momentUtils.numericalTime(b)
			)
		}
		return availableDays
	},
	menusHash: state => {
		if (!state.business || !state.business.menus) {
			return null
		}
		return state.business.menus.reduce((hash, menu) => {
			let categoryOrder =
				menu.products_categories != undefined
					? menu.products_categories
					: []

			categoryOrder = categoryOrder
				.slice()
				.sort((a, b) => a.position - b.position)
				.map(category => {
					return category.category_id
				})

			hash[menu.id] = {
				menu: menu,
				categoryOrder: categoryOrder
			}
			return hash
		}, {})
	},
	isLoggedIn: state => {
		return state.user && state.user.accessToken.length > 0
	},
	userProfileComplete: state => {
		return (
			state.user &&
			state.user.username.length > 0 &&
			state.user.email.length > 0
		)
	},
	isResidential: state => {
		return state.business && state.business.type == BusinessType.RESIDENTIAL
	},
	isAirport: state => {
		return state.business && state.business.type == BusinessType.AIRPORT
	},
	isGuestCheckoutAvailable: state => {
		if (state.user && state.user.id != 0) {
			return false
		} else if (router.app.$route.params.eventId) {
			const events = state.businessEvents ? state.businessEvents : []
			const event = events.find(
				event => event.id == router.app.$route.params.eventId
			)
			return (
				event &&
				event.status == EventStatus.ONGOING &&
				event.type == BusinessEventType.POPUP
			)
		}
		return false
	},
	businessAddress: state => {
		const business = state.business
		if (business && business) {
			return `${business.address}, ${business.city}, ${business.state} ${
				business.zip
			}`
		}
		return ""
	},
	businessLocation: state => {
		if (
			state.business &&
			state.business.locations &&
			state.business.locations[0]
		) {
			return state.business.locations[0]
		}
		return null
	},
	businessDropoffLocation: (state, getters) => {
		if (
			state.businessDropoffLocationId != null &&
			getters.businessLocation &&
			getters.businessLocation.dropoff_locations &&
			getters.businessLocation.dropoff_locations.length > 0
		) {
			const location = getters.businessLocation.dropoff_locations.find(
				location => location.id == state.businessDropoffLocationId
			)
			return location ? location : null
		}
		return null
	}
}
